import * as ngCore from '@angular/core'
import { Subject } from 'rxjs'

@ngCore.Directive({
  selector: '[radioValue]',
  standalone: true,
})
export class AtnDsRadioValue<T = unknown> {
  public readonly onClick = new Subject<void>()

  @ngCore.Input()
  public radioValue: T | undefined

  constructor(public readonly element: ngCore.ElementRef<HTMLElement>) {}

  @ngCore.HostListener('click')
  public onClickHandler(): void {
    this.onClick.next()
  }
}
